/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/react-in-jsx-scope */
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

import {
    scheduleService
} from '../../../../../../../service';
import { Icon, IconEye, IconScheduleEdit, IconScheduleRemove } from '../../../../../base/icons';

const ScheduledMeetingListItem = props => {

    const { user, sheduledMeetingItem, setShowMeetingDetail, setSelectedMeeting, deleteSchuleMeeting, onEditMeeting, order } = props;

    return (
        <div className={`o-sched-call-meeting-content-list-item ${order ? "last" : ""}`}>
            <div className='o-sched-call-meeting-content-list-item-name'>{sheduledMeetingItem?.meetingName}</div>
            <div className='o-sched-call-meeting-content-list-item-actions'>
                <span
                    onClick = { () => {
                        setShowMeetingDetail(true);
                        setSelectedMeeting(sheduledMeetingItem);
                    }}
                >
                    <Icon
                        size={24}
                        src={ IconEye }
                    />
                </span>
                {user.id ===sheduledMeetingItem.meetingOwner &&  <span
                    onClick = { () => onEditMeeting(sheduledMeetingItem) }
                >
                    <Icon
                        size={20}
                        src={ IconScheduleEdit }
                    />
                </span>}
                {user.id ===sheduledMeetingItem.meetingOwner &&  <span
                    onClick = { () => deleteSchuleMeeting(sheduledMeetingItem) }
                >
                    <Icon
                        size={20}
                        src={ IconScheduleRemove }
                    />
                </span>}
            </div>
        </div>

    );

};

ScheduledMeetingListItem.propTypes = {
    deleteSchuleMeeting: PropTypes.func,
    onEditMeeting: PropTypes.func,
    setSelectedMeeting: PropTypes.func,
    setShowMeetingDetail: PropTypes.func,
    sheduledMeetingItem: {
        meetingName: PropTypes.string
    },
    user: PropTypes.shape()
};

export default ScheduledMeetingListItem;
